export default __webpack_public_path__ + "static/media/rightArrow.58a4c037.svg";